import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MemberDetails, config, BalanceQuery, MemberQuery, MemberCard, MemberCardQuery, MemberService } from '@fgb/core';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'fgb-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
})
export class AccountDetailsComponent implements OnInit {
  member$: Observable<MemberDetails | undefined>;
  memberDetails: MemberDetails;
  accountsDetailsForm: FormGroup;
  combinedCard$: Observable<number | undefined>;
  loyaltyPointsCard$: Observable<number | undefined>;
  card$: Observable<MemberCard | undefined>;
  allowEditing: boolean = false;

  constructor(
    private memberService: MemberService,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.member$ = this.memberQuery.selectMemberDetails().pipe(
      tap((x) => {
        if (x !== undefined) {
          this.memberDetails = x;
          this.accountsDetailsForm = this.formBuilder.group({
            FirstName: [x.FirstName, [Validators.required]],
            Surname: [x.Surname, [Validators.required]],
          });
        }
      })
    );
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.card$ = this.memberCardQuery.selectCurrentCard();
  }

  shippingSaved(e: any) {
    if (this.allowEditing != null) {
      let memberDetails = {
        ...this.memberDetails,
        AddressName: e.AddressName,
        Street: e.Street,
        Town: e.Town,
        Country: e.Country,
        County: e.County,
        PostCode: e.Postcode,
        FirstName: e.FirstName ?? this.memberDetails.FirstName,
        Surname: e.Surname ?? this.memberDetails.Surname,
      } as MemberDetails;

      this.memberService.updateMemberDetails(this.memberDetails.PortalId, memberDetails);
      this.allowEditing = false;
    }
  }
}
